
export function translateErrorKey(errKey, t) {
  if (!errKey || typeof errKey !== 'string') return t('error.general');

  // Известные префиксы, которые сами являются ключами перевода
  const translatableKeyPrefixes = ['vdot_commentary.', 'error.volume_'];
  const isTranslatableKey = translatableKeyPrefixes.some((prefix) => errKey.startsWith(prefix));

  if (isTranslatableKey) {
    return t(errKey);
  }

  return errKey;  // обычный текст ошибки с бэка — показываем как есть
}

export const errorMessagesMap = {
    'Темп должен быть между 2.0 и 30.0 мин/км.': 'error.pace_out_of_range',
    'Дистанция должна быть положительной.': 'error.distance_positive',
    'Дистанция не может превышать 100 км.': 'error.distance_too_large',
    'Загрузите правильное изображение. Файл, который вы загрузили, поврежден или не является изображением.': 'error.invalid_image',
    'Загруженный файл не является корректным файлом.': 'error.invalid_file',
  };

  export function getTranslatedError(message, t) {
    const key = errorMessagesMap[message];
    if (key) {
      return t(key);
    }
    return message; 
  }